import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CATALAN, LANGUAGE_SPANISH } from '@app/@core/constants/requests.constants';
import { DOWNLOAD, URL_PATH, VIEW, URL_PILLS_DOCUMENTATION } from '@app/@core/constants/training.constants';
import { PrintStore } from '@app/@shared';
import { AuthorizationDTO, PrintContractDTO } from '@app/requests/model/requests-model';
import { DocumentInterestDTO, PillDocumentsDTO } from '@app/training/model/training.model';
import { TrainingStore } from '@app/training/services/training.store';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';

@Component({
  selector: 'scf-formation-data-item',
  templateUrl: './formation-data-item.component.html',
  styleUrls: ['./formation-data-item.component.scss'],
})
export class FormationDataItemComponent implements OnInit {
  @Input() private element: DocumentInterestDTO & PillDocumentsDTO;
  @Input() private type: string;
  @Input() private isAutos: string;
  @Input() private isConsumption: string;

  public title: string;
  public size: string;
  public class: string;

  constructor(
    private trainingStore: TrainingStore,
    private printStore: PrintStore,
    private datePipe: DatePipe,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    if (this.element) {
      if (this.element.name && this.type !== 'pills') {
        this.title = this.element.name;
      } else {
        this.title = this.element.title;
      }
      if (!this.element.jasper) {
        const route =
          this.type === 'pills' ? URL_PILLS_DOCUMENTATION + this.element.name : URL_PATH + this.element.filename;
        this.trainingStore.getPdfFromAssets(route).then((data) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileSize = Math.round(file.size / 1000);
          this.size = fileSize?.toString() + ' KB';
        });
      } else if (this.element.jasper) {
        this.viewOrprintJasper(undefined);
      }
      this.class =
        this.translateService.instant(this.title)?.includes('Formulario') ||
        this.translateService.instant(this.title)?.includes('Solicitud') ||
        this.translateService.instant(this.title)?.includes('Sol·licitud') ||
        this.translateService.instant(this.title)?.includes('Formulari')
          ? 'icon-ic_pdf_scf'
          : 'icon-ic_document';
    }
  }

  public downloadFile(): void {
    if (this.element.jasper) {
      this.viewOrprintJasper(DOWNLOAD);
    } else {
      const route =
        this.type === 'pills' ? URL_PILLS_DOCUMENTATION + this.element.name : URL_PATH + this.element.filename;
      this.trainingStore.getPdfFromAssets(route).then((data) => {
        let file = new Blob([data], { type: 'application/pdf' });
        FileSaver.saveAs(file, this.translateService.instant(this.title));
      });
    }
  }

  public viewFile(): void {
    if (this.element.jasper) {
      this.viewOrprintJasper(VIEW);
    } else {
      if (this.type === 'pills') {
        const route = URL_PILLS_DOCUMENTATION + this.element.name;
        console.log(route);
        window.open(route);
      } else {
        const route = URL_PATH + this.element.filename;
        window.open(route);
      }
    }
  }

  private viewOrprintJasper(mode: string) {
    if (this.isAutos || this.isConsumption) {
      let printContract: PrintContractDTO = {
        bindOffer: 'N',
        coBrand: '',
        codeOperative: 'STD',
        codeProduct: 99,
        dateEntry: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
        isIne: '',
        language: this.title === 'formationDocumentation.doc.es.creditRequest' ? LANGUAGE_SPANISH : LANGUAGE_CATALAN,
        notary: '',
        numOperation: '',
        versionContract: '',
        versionPolicy: '',
        authorization: 'S',
      };

      this.printStore.printContract(printContract).then((data) => {
        let file = new Blob([data], { type: 'application/pdf' });
        if (mode === VIEW) {
          let fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else if (mode === DOWNLOAD) {
          FileSaver.saveAs(file, this.translateService.instant(this.title) + '.pdf');
        } else {
          const fileSize = Math.round(file.size / 1000);
          this.size = fileSize?.toString() + ' KB';
        }
      });
    } else {
      if (this.title === 'formationDocumentation.doc.es.creditRequest') {
        this.printStore
          .downloadAuthorization(this.createEmptyAuthorizationDTO(LANGUAGE_SPANISH), mode)
          .then((data) => this.setSize(data));
      } else if (this.title === 'formationDocumentation.doc.ca.creditRequest') {
        this.printStore
          .downloadAuthorization(this.createEmptyAuthorizationDTO(LANGUAGE_CATALAN), mode)
          .then((data) => this.setSize(data));
      } else {
        this.printJasper(mode);
      }
    }
  }

  private printJasper(mode: string) {
    this.trainingStore.printJasper(this.element.id).then(
      (data) => {
        if (data) {
          let file = new Blob([data], { type: 'application/pdf' });
          if (mode === VIEW) {
            let fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else if (mode === DOWNLOAD) {
            FileSaver.saveAs(file, this.translateService.instant(this.title) + '.pdf');
          } else {
            const fileSize = Math.round(file.size / 1000);
            this.size = fileSize?.toString() + ' KB';
          }
        }
      },
      (error) => console.error(error)
    );
  }

  private setSize(fileData: any) {
    let file = new Blob([fileData], { type: 'application/pdf' });
    const fileSize = Math.round(file.size / 1000);
    this.size = fileSize?.toString() + ' KB';
  }

  private createEmptyAuthorizationDTO(language: string): AuthorizationDTO {
    return {
      brand: '',
      city: '',
      date: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
      establishment: '',
      holderDTO: {
        accountHolding: '',
        addressNumber: '',
        amountCard: '',
        annualIngr: '',
        antiquityProperty: '',
        birthDate: '',
        civilStatus: '',
        cnae: '',
        comDom: '',
        companyCif: '',
        companyName: '',
        companyPopulation: '',
        companySector: '',
        countryBirth: '',
        dcBank: '',
        documentId: '',
        door: '',
        email: '',
        entityBank: '',
        errorField: '',
        expirationDate: '',
        floor: '',
        houseTel: '',
        housingExpenses: '',
        iban: '',
        incomeNetos: '',
        incorpMonth: '',
        incorpYear: '',
        indAuthorization: '',
        ingrMonthVble: '',
        insurance: '',
        mobileTel: '',
        modPaymentCard: '',
        name: '',
        nameAddress: '',
        nationality: '',
        noEmail: true,
        noMobile: true,
        numberBank: '',
        observations: '',
        occupation: '',
        officeBank: '',
        peopleInCharge: '',
        postcode: '',
        regime: '',
        secondSurname: '',
        sex: '',
        sitVivienda: '',
        subSit: '',
        surname: '',
        telCompany: '',
        town: '',
        workSituation: '',
      },
      language: language,
      operative: null,
      participants: [
        {
          amountNetDatFind: '',
          dateDatFinIndiv: '',
          accountHolding: '',
          addressNumber: '',
          amountCard: '',
          annualIngr: '',
          antiquityProperty: '',
          birthDate: '',
          civilStatus: '',
          comDom: '',
          companyCif: '',
          companyName: '',
          companyPopulation: '',
          companySector: '',
          countryBirth: '',
          dcBank: '',
          documentId: '',
          door: '',
          email: '',
          endContractDate: '',
          entityBank: '',
          expirationDate: '',
          floor: '',
          houseTel: '',
          housingExpenses: '',
          iban: '',
          incomeNetos: '',
          incorpMonth: '',
          incorpYear: '',
          indAuthorization: '',
          ingrMonthVble: '',
          insurance: '',
          jobPosition: '',
          mobileTel: '',
          modPaymentCard: '',
          name: '',
          nameAddress: '',
          nationality: '',
          noMobile: false,
          noEmail: true,
          numberBank: '',
          observations: '',
          occupation: '',
          officeBank: '',
          originRevenues: '',
          otherExpenses: '',
          postcode: '',
          relationHolder: '',
          secondSurname: '',
          sex: '',
          sitVivienda: '',
          subSit: '',
          surname: '',
          telCompany: '',
          town: '',
          typeCoHolder: '',
          workSituation: '',
          cnae: '',
        },
      ],
    };
  }
}
